<template>
  <div class="alert">
    <div class="filter-container">
      <el-input size="medium" placeholder="Plate" v-model="search" clearable debounce @input="changeInput()"
        :style="{ width: '300px', marginRight: '20px' }" />
      <el-button size="medium" type="primary" @click="handleSearch()">Search</el-button>
    </div>

    <el-table :data="list.slice(
      (listQuery.page - 1) * listQuery.limit,
      listQuery.page * listQuery.limit
    )
      " v-loading="listLoading" style="width: 100%;" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="S/N" width="100">
        <template slot-scope="{ row, $index }">
          <span>{{$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="vehicle_plate" label="Plate" width="250"></el-table-column>
      <el-table-column prop="tyre_id" label="Sensor ID" width="250"></el-table-column>
      <el-table-column 
        prop="message" 
        label="Message"
        style="text-align: left;"
        >

      </el-table-column>
      <el-table-column prop="time" label="Time" width="300">
        <template slot-scope="scope">
          <span>{{ moment(scope.row.time).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
      </el-table-column>
     
    </el-table>
    <div class="ls-page">
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        @pagination="getDataList" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from "components/pagination";

import { getAlertList } from "network/alert";

export default {
  name: "Alert",
  components: { Pagination },
  data() {
    return {
      search: "",
      type: "",
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
      },
      list: [],
      moment: moment
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.listLoading = false;
      getAlertList()
        .then((data) => {
          this.listLoading = false;

          this.list = data.data;
          this.total = this.list.length;
        })
        .catch((err) => {
          this.$message.error("Interface error: get_alert_list");
        });
    },
    changeInput() {
      if (this.search === "") {
        this.getDataList();
      }
    },
    handleSearch() {
      this.listLoading = false;
      getAlertList()
        .then((data) => {
          if (data.status === 200) {
            this.listLoading = false;

            this.list = data.data;
            this.total = this.list.length;
          }
        })
        .then(() => {
          let newList = [];
          newList = this.list.filter((item, index) => {
            const plate = item.vehicle_plate.toUpperCase().indexOf(this.search.toUpperCase()) !== -1;

            if (plate) {
              return true;
            }
          });

          this.list = newList;
          this.total = newList.length;
        })
        .catch((err) => {
          this.$message.error("Interface error: get_alert_list");
        });
    }
  },
};
</script>

<style scoped>

::v-deep .el-table .cell {
  word-break: break-word;
}
.alert .status {
  display: block;
  margin: 0 auto;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: red;
}
.alert .status.idle{
  background-color: green;
}
.ls-page {
  float: right;
}

.addUser {
  font-size: 32px;
  cursor: pointer;
}

.editUser {
  font-size: 28px;
  cursor: pointer;
}

.delUser {
  /* margin-left: 10px; */
  font-size: 28px;
  cursor: pointer;
  color: red;
}

.userForm .el-select {
  width: 100%;
}
</style>
